module.exports = __webpack_public_path__ + "static/media/on.5cbf5d21.svg";